import { com } from '@eidu/web'
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import EntityId = com.eidu.entity.EntityId
import PermissionGrantId = com.eidu.entity.permission.PermissionGrantId
import PermissionPolicyId = com.eidu.entity.permission.PermissionPolicyId

export const entityTypeKeys = {
  all: ['entityType'] as const,
  list: () => [...entityTypeKeys.all, 'list'] as const,
  detail: (id: EntityTypeId) => [...entityTypeKeys.all, 'detail', id.toString()] as const,
}

export const entityKeys = {
  all: ['entity'] as const,
  detail: (id: EntityId) => [...entityKeys.all, 'detail', id.toString()] as const,
  byId: (id: EntityId) => [...entityKeys.all, 'byId', id.toString()] as const,
  ofType: (typeId: EntityTypeId) => [...entityKeys.all, 'ofType', typeId.toString()] as const,
}

export const permissionGrantKeys = {
  all: ['permissionGrant'] as const,
  page: (pageIndex: number, pageSize: number) => [...permissionGrantKeys.all, 'page', pageIndex, pageSize] as const,
  detail: (id: PermissionGrantId) => [...permissionGrantKeys.all, 'detail', id.toString()] as const,
}

export const permissionPolicyKeys = {
  all: ['permissionPolicy'] as const,
  detail: (id: PermissionPolicyId) => [...permissionPolicyKeys.all, 'detail', id.toString()] as const,
}

export const permittedActionsKeys = {
  all: ['permittedActions'] as const,
  forRequest: (requestKey: readonly string[]) => [...permittedActionsKeys.all, requestKey] as const,
}

export const semanticLinkKeys = {
  all: ['semanticLink'] as const,
  list: () => [...semanticLinkKeys.all, 'list'] as const,
}

export const formContentKeys = {
  all: ['formContent'] as const,
  detail: (formId: string, formContentId: string) => [...formContentKeys.all, 'detail', formId, formContentId] as const,
}

export const auditLogKeys = {
  all: ['audit-log'] as const,
}

export const registryAssetKeys = {
  all: ['registryAsset'] as const,
  detail: (entityId: string) => [...registryAssetKeys.all, 'detail', entityId] as const,
}
